import React from "react";
import styles from "./Tabs.module.css";

const Tabs = ({ tabs, activeTab, onChange }) => (
  <div className={styles.tabsContainer}>
    {tabs.map((tab) => (
      <button
        key={tab.key}
        className={`${styles.tabButton} ${activeTab === tab.key ? styles.active : ""}`}
        onClick={() => onChange(tab.key)}
      >
        {tab.icon && <span>{tab.icon}</span>}
        {tab.label}
      </button>
    ))}
  </div>
);

export default Tabs;